<div class="fixed right-6 z-40 flex flex-col items-end bottom-[calc(4.5rem+env(safe-area-inset-bottom,0px)+0.75rem)] lg:bottom-6">
  
  <!-- Chat Popup -->
  @if (isOpen()) {
    <div class="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl border border-slate-200 dark:border-slate-800 w-80 sm:w-96 mb-4 flex flex-col overflow-hidden transition-all duration-300 transform origin-bottom-right"
         style="max-height: 500px;">
      
      <!-- Header -->
      <div class="bg-brand-500 text-white p-4 flex justify-between items-center rounded-t-3xl shadow-sm z-10 relative">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-md border border-white/20">
            <ng-icon name="lightbulb" size="20"></ng-icon>
          </div>
          <div>
            <h3 class="font-bold text-sm">Boîte à suggestions</h3>
            <p class="text-xs text-white/80">Aidez-nous à améliorer GymO !</p>
          </div>
        </div>
        <button (click)="toggleChat()" class="text-white/80 hover:text-white hover:bg-white/10 rounded-full p-2 transition-colors cursor-pointer outline-none">
          <ng-icon name="x" size="20"></ng-icon>
        </button>
      </div>

      <!-- Messages Area -->
      <div class="flex-1 overflow-y-auto p-4 space-y-4 bg-slate-50 dark:bg-slate-950 min-h-[250px] max-h-[350px] relative">
        
        @if (loading()) {
          <div class="flex justify-center items-center h-full min-h-[100px]">
            <ng-icon name="loader" size="24" class="text-brand-500 animate-spin"></ng-icon>
          </div>
        } @else {
          
          @if (suggestions().length === 0) {
            <div class="flex flex-col items-center justify-center text-slate-500 dark:text-slate-400 text-sm mt-8 opacity-70">
              <ng-icon name="message-square" size="32" class="mb-3"></ng-icon>
              <p class="text-center font-medium">Aucune suggestion pour le moment.<br>Soyez le premier à contribuer !</p>
            </div>
          }

          @for (s of suggestions(); track s.id) {
            <div class="bg-white dark:bg-slate-900 p-3.5 rounded-2xl rounded-tr-sm shadow-sm border border-slate-100 dark:border-slate-800 ml-4 relative self-end flex flex-col gap-2">
              <p class="text-sm text-slate-800 dark:text-slate-200">{{ s.suggestion }}</p>
              <div class="flex justify-between items-center text-[10px]">
                <span class="text-slate-400 font-medium">{{ s.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
                <span class="px-2 py-0.5 rounded-full border font-bold uppercase tracking-wider" [ngClass]="getStatusClass(s.status)">
                  {{ s.status_label || s.status }}
                </span>
              </div>
            </div>
          }

        }
      </div>

      <!-- Input Area -->
      <div class="p-3 bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800">
        <form (ngSubmit)="submitSuggestion()" class="relative flex items-center">
          <input
            type="text"
            name="suggestionInput"
            [(ngModel)]="newSuggestion"
            placeholder="Votre brillante idée..."
            class="w-full bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 text-sm rounded-full pl-4 pr-12 py-3 focus:outline-none focus:ring-2 focus:ring-brand-500/50 focus:border-brand-500 transition-all text-slate-800 dark:text-slate-100 placeholder-slate-400"
            [disabled]="submitting()"
          >
          <button 
            type="submit" 
            [disabled]="!newSuggestion().trim() || submitting()"
            class="absolute right-1.5 w-9 h-9 rounded-full flex items-center justify-center bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm cursor-pointer"
          >
            @if (submitting()) {
              <ng-icon name="loader" size="16" class="animate-spin"></ng-icon>
            } @else {
              <ng-icon name="send" size="16" class="ml-0.5"></ng-icon>
            }
          </button>
        </form>
      </div>
      
    </div>
  }

  <!-- Floating Button -->
  <button
    (click)="toggleChat()"
    class="bg-brand-500 text-white rounded-full px-5 h-14 shadow-xl hover:shadow-brand-500/30 hover:-translate-y-1 hover:bg-brand-600 transition-all duration-300 flex items-center gap-3 border border-white/20 z-50 cursor-pointer group relative overflow-hidden"
  >
    <div class="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out"></div>
    <ng-icon name="lightbulb" size="24" class="relative z-10"></ng-icon>
    <span class="font-bold text-sm tracking-wide relative z-10 hidden sm:inline-block">Faire une suggestion</span>
  </button>
</div>
